import React from 'react';
import { Grid, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import profile from "../../assets/profile.jpg";
import Seo from "../../Components/Seo";

const About = () => {
    return (
        <Box sx={{ minHeight: '100vh', py: { xs: 3, sm: 4 } }}>
            <Seo
                title="About Dr. Shubham Arora"
                description="Learn about Dr. Shubham Arora, MD Radiology, and the educational mission behind Radiology Illustration."
                canonicalPath="/about"
            />
            <Grid container spacing={2}
                justifyContent="center"
                alignItems="center"
                sx={{ textAlign: 'center', px: { xs: 2, sm: 4 } }} >
                <Grid size={12}>
                    <Typography
                        variant="h1"
                        gutterBottom
                        sx={{
                            display: 'block',
                            fontSize: {
                                xs: '1.75rem',
                                sm: '2.5rem',
                                md: '3rem',
                            },
                            fontWeight: 700,
                            mb: { xs: 2, sm: 3 },
                        }}
                    >
                        Dr. Shubham Arora
                    </Typography>
                </Grid>
                <Grid size={{ lg: 6, md: 6, sm: 12 }}>
                    <img
                        src={profile}
                        alt="Shubham Arora"
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '600px',
                            objectFit: 'cover',
                            display: 'block',
                            borderRadius: '8px',
                        }}
                    />
                </Grid>
                <Grid size={{ lg: 6, md: 6, sm: 12 }}>
                    <Typography
                        variant="body1"
                        sx={{
                            textAlign: 'center',
                            fontSize: {
                                xs: '0.9rem',
                                sm: '1rem',
                                md: '1.125rem',
                            },
                            lineHeight: {
                                xs: 1.7,
                                sm: 1.6,
                            },
                            px: { xs: 1, sm: 2 },
                            mt: { xs: 2, sm: 0 },
                        }}
                    >
                        I am Dr. Shubham Arora, MD Radiology with avid interest in academics and medical illustrations. Over the past eight years, I have been dedicated to creating high impact visual content that simplifies the complex worlds of radiology and anatomy. My illustrations aim to bridge the gap between intricate medical concepts and intuitive understanding, making learning more accessible and enjoyable for students, educators, and healthcare professionals alike. This website is a reflection of my mission to transform the way radiology and anatomy are learned and taught. Through meticulously crafted illustrations, I hope to provide a visual learning platform that supports academic growth, aids in clinical practice, and inspires a deeper appreciation of medical imaging. Whether you're a student revising core concepts or a clinician seeking visual aids for teaching, you'll find resources here designed to clarify, educate, and engage.
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            textAlign: 'center',
                            fontSize: {
                                xs: '0.9rem',
                                sm: '1rem',
                                md: '1.125rem',
                            },
                            lineHeight: 1.7,
                            px: { xs: 1, sm: 2 },
                            mt: 2,
                            color: 'text.secondary',
                        }}
                    >
                        Radiology Illustration is an independent educational website. It is designed to support learning and teaching, not to replace clinical training, peer-reviewed references, or professional medical judgment.
                    </Typography>
                </Grid>
            </Grid>


        </Box>
    );
};

export default About;
